<template>
  <div class="products-table-header">
    <BaseText class="table-header-text">Produtos da carteira</BaseText>
    <BaseText class="table-header-text">Investimento Mínimo</BaseText>
    <BaseText class="table-header-text">Valor a Investir</BaseText>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { BaseText }
})
export default class ProductsToInvestHeader extends Vue {}
</script>
<style lang="less" scoped>
.products-table-header {
  display: grid;
  grid-template-columns: 6fr 3fr 2fr;
  border-bottom: 1px solid @divider-primary;
}
.table-header-text {
  padding: @size-spacing-x600 0px @size-spacing-x600 @size-spacing-x400;
  .text-p-6();
  font-weight: 600;
}
</style>
